import {HeaderConfig, Row} from 'components/Table/KhulaSupplierTable';
import {IInvoiceBundle} from 'constants/interfaces';
import moment from 'moment';
import {_NumberWithSpaces} from 'constants/index';
import React from 'react';
import {Box, Link} from '@material-ui/core';
import NavigationService from 'services/NavigationService';

export const orderBundleTableHeaders = (): HeaderConfig[] => [
  {
    field: 'formattedId',
    title: 'Order Bundle',
    isSortable: true,
    sortField: 'id',
    isSearchable: true,
    searchField: 'id',
    isRightAligned: true,
  },
  {
    field: 'formattedDate',
    title: 'Date',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
  },
  {
    field: 'farmerFullName',
    title: 'Farmer',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
  },
  {
    field: 'formattedNumOrders',
    title: '#Orders',
    isSortable: true,
    isSearchable: true,
    isRightAligned: false,
  },
  {
    field: 'formattedOrders',
    title: 'Orders',
    isSortable: false,
    isSearchable: false,
    isRightAligned: false,
  },
  {
    field: 'formattedTotal',
    title: 'Total (R)',
    sortField: 'total',
    isSortable: true,
    isSearchable: false,
    isRightAligned: true,
    noWrap: true,
  },
  {
    field: 'actions',
    title: '',
    isSortable: false,
    isSearchable: false,
    isRightAligned: true,
  },
];

export const formattedOrderBundleId = (order: IInvoiceBundle) =>
  `KHULA-${order.id}`;

export const formattedFarmerFullName = (order: IInvoiceBundle) => {
  const farmer = order.invoices?.[0]?.farmer;
  return farmer ? `${farmer.name} ${farmer.surname}` : '';
};

export const orderBundleTableRows = (
  invoiceBundles: IInvoiceBundle[],
  onSelect: (order: IInvoiceBundle) => any,
): Row[] =>
  invoiceBundles.map((invoiceBundle) => {
    // Provide a real "id" field for the Row type:
    const id = Number(invoiceBundle.id) || 0;
    const formattedId = formattedOrderBundleId(invoiceBundle);
    const formattedDate = moment(
      parseInt(invoiceBundle.insertedOn || '0', 10),
    ).format('YYYY-MM-DD');
    const farmerFullName = formattedFarmerFullName(invoiceBundle);
    const formattedNumOrders = invoiceBundle.invoices.length;
    const formattedTotal = 'R ' + _NumberWithSpaces(invoiceBundle.total);

    return {
      // Satisfy Row's required "id"
      id,
      formattedId,
      formattedDate,
      farmerFullName,
      formattedNumOrders,
      formattedTotal,
      formattedOrders: <OrderList orderBundle={invoiceBundle} />,
      actions: <OrderBundleRowIcons onSelect={() => onSelect(invoiceBundle)} />,
    };
  });

export const OrderBundleTableFilters = [];

// Minimal row icons example
function OrderBundleRowIcons(props: {onSelect: () => any}) {
  return (
    <Box display="flex" flexDirection="row">
      {/* Icons here */}
    </Box>
  );
}

// Minimal order list example
function OrderList(props: {orderBundle: IInvoiceBundle}) {
  return (
    <Box display="flex" flexDirection="column">
      {props.orderBundle.invoices.map((invoice) => (
        <Link
          key={invoice.id}
          style={{color: 'blue'}}
          onClick={() => NavigationService.navigate(`/orders/${invoice.id}`)}
        >
          Khula-{invoice.id}
        </Link>
      ))}
    </Box>
  );
}
